import { render, staticRenderFns } from "./VuesticFeed.vue?vue&type=template&id=556bea0a"
import script from "./VuesticFeed.vue?vue&type=script&lang=js"
export * from "./VuesticFeed.vue?vue&type=script&lang=js"
import style0 from "./VuesticFeed.vue?vue&type=style&index=0&id=556bea0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports